import * as React from 'react';
import { Rect } from '../types';
import { DrawingAction, startTextEditing, changeText } from '../actions/DrawingAction';

interface TextBoxProps {
  rect: Rect;
  scale: number;
  translateY: number;
  translateX: number;
  font: string;
  lineHeight: number;
  padding: number;
  defaultValue: string;
  onDrawingAction: (action: DrawingAction) => void;
  onBlur: () => void;
}

export default class TextBox extends React.Component<TextBoxProps, {}> {
  private textarea: HTMLTextAreaElement | null = null;
  private editTextStarted: boolean = false;

  public constructor(props: TextBoxProps) {
    super(props);
  }

  public handleInput = (event: React.FormEvent<HTMLTextAreaElement>) => {
    if (!this.editTextStarted) {
      this.props.onDrawingAction(startTextEditing());
      this.editTextStarted = true;
    }
    const { value } = event.currentTarget;
    this.props.onDrawingAction(changeText(value));
  }

  private handleKeyDown = (ev: KeyboardEvent) => {
    ev.stopPropagation();
  }

  public render() {
    const { rect, scale, translateX, translateY, font, lineHeight, padding } = this.props;
    const { x, y, width, height } = rect;
    const style: React.CSSProperties = {
      font,
      lineHeight,
      display: 'block',
      position: 'absolute',
      top: `${y * scale + translateY}px`,
      left: `${x * scale + translateX}px`,
      width: `${width - padding * 2}px`,
      height: `${height - padding * 2}px`,
      transformOrigin: 'left top',
      transform: `scale(${scale})`,
      background: 'transparent',
      border: 'none',
      outline: 'none',
      padding: `${padding}px`,
      resize: 'none',
      wordBreak: 'break-all',
      overflow: 'hidden',
    };

    return <textarea
      ref={el => this.textarea = el}
      lang="ja"
      spellCheck={false}
      maxLength={1000} // TODO: 幅高さ文字サイズから適切なものを設定すること
      style={style}
      onBlur={this.props.onBlur}
      onInput={this.handleInput}
    />;
  }

  public componentDidMount() {
    if (this.textarea !== null) {
      this.textarea.addEventListener('keydown', this.handleKeyDown, false);
      this.textarea.focus();
      // In order to set textarea cursor to end of text, value is set here.
      this.textarea.value = this.props.defaultValue;
    }
  }

  public componentWillUnmount() {
    if (this.textarea !== null) {
      this.textarea.removeEventListener('keydown', this.handleKeyDown);
      this.textarea.blur();
    }
  }
}
